import styled from '@emotion/styled';

const StyledCheckbox = styled.input`
  margin-right: 5px;
`;

const StyledSpan = styled.span`
  width: 36px;
  display: inline-block;
  padding: 0px 0px 0px 2px;
`;

export default function CheckboxButtonInput({
  checked,
  children,
  onClick,
  variant,
  unfixedWidth,
  ...rest
}) {
  return (
    <>
      <StyledCheckbox
        type="checkbox"
        checked={checked}
        role="checkbox"
        aria-checked={checked}
        aria-label={children}
        onChange={onClick}
        {...rest}
      />
      <StyledSpan>{children}</StyledSpan>
    </>
  );
}
